
import { Vue, Component, Prop } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'

interface Eligibility {
  text: string;
  description: string;
}

@Component({
  name: 'EligibilityPreview',
  components: {
    ChoiceIcon
  }
})
export default class EligibilityPreview extends Vue {
  @Prop() title!: string
  @Prop() eligibility!: Eligibility
}
